export default __webpack_public_path__ + "static/media/robert-james-fischer.6569a21a.txt";